/**
 * @file: 医典 request
 */
import { request } from './request';
import { ApiConfigs, Response } from '../schemas/service';

const api: ApiConfigs = {
  queryCommonSymptoms: {
    // url:
    // 'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/medicalCode/commonSymptoms',
    url: '/health/api/v1/medicalCode/commonSymptoms',
    method: 'GET'
  },
  queryFollowSymptoms: {
    url: '/health/api/v1/medicalCode/followSymptoms',
    method: 'GET'
  },
  queryPartMenu: {
    url: '/health/api/v1/medicalCode/bodyParts',
    method: 'GET'
  },
  querySymptomsById: {
    url: '/health/api/v1/medicalCode/symptomsByBodyPartId',
    method: 'GET'
  },
  followSymptom: {
    url: '/health/api/v1/medicalCode/addFollowSymptoms',
    method: 'POST'
  },
  unfollowSymptom: {
    url: '/health/api/v1/medicalCode/cancelFollowSymptoms',
    method: 'POST'
  },
  queryPopularScienceList: {
    url: '/health/api/v1/home/queryPopularScienceList',
    method: 'GET'
  },
  postPopularScienceLike: {
    url: '/health/api/v1/home/popularScienceUseful',
    method: 'POST'
  }
};

export interface ICommontSymptom {
  key: string;
  value: string;
}

export interface ISymptom {
  id: number;
  photoNum: number;
  symptoms: string;
}

export interface IPart {
  bodyParts: string;
  id: number;
}

export interface IBaike {
  coverUrl: string;
  createTime: string;
  createUser: string;
  doctorId: number;
  id: number;
  onlineTime: string;
  pid: number;
  shareUrl: string;
  theme: string;
  updateTime: string;
  updateUser: string;
  useful: boolean;
}

export interface IBaikeList {
  lastMark: boolean;
  list: IBaike[];
  pageNum: number;
  pageSize: number;
  total: number;
}

const baike = {
  async getCommonSymptoms() {
    try {
      const response: Response<ICommontSymptom[]> = await request(
        api.queryCommonSymptoms
      );
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getFollowSymptoms() {
    try {
      const response: Response<ISymptom[]> = await request(
        api.queryFollowSymptoms
      );
      const { result = [] } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getPartMenu() {
    try {
      const response: Response<IPart[]> = await request(api.queryPartMenu);
      const { result = [] } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getSymptomsById(bodyPartId) {
    try {
      const response: Response<ISymptom[]> = await request(
        api.querySymptomsById,
        {
          bodyPartId
        }
      );
      const { result = [] } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async followSymptom(targetId) {
    try {
      const response: Response<boolean> = await request(api.followSymptom, {
        targetId
      });
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async unfollowSymptom(targetId) {
    try {
      const response: Response<boolean> = await request(api.unfollowSymptom, {
        targetId
      });
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getPopularScienceList({ pageNum, pageSize }) {
    try {
      const response: Response<IBaikeList> = await request(
        api.queryPopularScienceList,
        {
          pageNum,
          pageSize
        }
      );
      const { result } = response;
      return result;
    } catch (err) {
      return Promise.reject(err);
    }
  },

  async postPopularScienceLike(popularScienceId, attention = 1) {
    try {
      const response: Response<IBaikeList> = await request(
        api.postPopularScienceLike,
        {
          popularScienceId,
          attention
        }
      );
      const { result } = response;
      return result;
    } catch (err) {
      return Promise.reject(err);
    }
  }
};

export default baike;
